<template>
  <div class="clearfix home">
    <div class="banners">
      <swiper
        ref="mySwiper"
        name="IndexmySwiper"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="item in ajaxItemsBanners"
          :key="item.ID"
        >
          <img :src="item.Attachment" />
        </swiper-slide>
        <div
          class="swiper-pagination"
          slot="pagination"
        ></div>
        <div
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
      </swiper>
    </div>
    <div class="toutiao">
      <div class="container">
        <div class="toutiao_content">
          <h1 class="animated fadeInRight">
            <router-link
              :to="{
                name: 'content',
                params: { id: ajaxItemsNewsFirst.ID },
              }"
              :title="ajaxItemsNewsFirst.Title"
            >
              {{ ajaxItemsNewsFirst.Title }}
            </router-link>
          </h1>
          <!-- <div
            class="animated zoomIn"
            style="text-indent:2em;"
            v-html="ajaxItemsNewsFirst.Description"
          ></div> -->
        </div>
      </div>
    </div>
    <div class="clearfix container">
      <el-row>
        <el-col
          :span="12"
          :xs="24"
        >
          <div class="box">
            <div class="box-title">
              <router-link :to="{
                  name: 'channel',
                  params: { channelID: '5cb3f079e1382306c3acac57' },
                }">
                <i class="fas fa-list"></i>新闻动态
              </router-link>
              <router-link
                :to="{
                  name: 'channel',
                  params: { channelID: '5cb3f079e1382306c3acac57' },
                }"
                class="more"
              >
                更多...
              </router-link>
            </div>
            <div class="box-content">
              <p
                class="item dateGroup"
                v-for="item in ajaxItemsNews"
                :key="item.ID"
              >
                <router-link
                  :to="{
                    name: 'content',
                    params: { id: item.ID },
                  }"
                  :title="item.Title"
                  target="_blank"
                >
                  <i :class="article_icon"></i>
                  <span v-html="item.Title"></span>
                </router-link>
                <span class="date">{{ item.CreatedAt | formatDate }}</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
        >
          <div class="box index_news_photo">
            <swiper
              :options="mySwiperNewsOption"
              ref="mySwiperNews"
              :auto-update="true"
              :auto-destroy="true"
            >
              <swiper-slide
                v-for="item in ajaxItemsNewsCarousel"
                :key="item.ID"
              >
                <img
                  :src="item.Attachment"
                  :alt="item.Title"
                />
                <div class="index_news_photo_swiper_text">
                  <router-link :to="{
                      name: 'content',
                      params: { id: item.ID },
                    }">
                    {{ item.Title | formatHTML2Str }}
                  </router-link>
                </div>
              </swiper-slide>
              <div
                class="swiper-button-prev swiper-button-white"
                slot="button-prev"
              ></div>
              <div
                class="swiper-button-next swiper-button-white"
                slot="button-next"
              ></div>
            </swiper>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="box">
            <img
              src="../assets/b1.jpg"
              alt
            />
          </div>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
        >
          <div class="box">
            <div class="box-title">
              <router-link :to="{
                  name: 'channel',
                  params: { channelID: '5cb3f083e1382306c3acac58' },
                }">
                <i class="fas fa-warehouse"></i>媒体报道
              </router-link>
              <router-link
                :to="{
                  name: 'channel',
                  params: { channelID: '5cb3f083e1382306c3acac58' },
                }"
                class="more"
              >
                更多...
              </router-link>
            </div>
            <div class="box-content">
              <p
                class="item dateGroup"
                v-for="item in ajaxItemsNewsMeiTi"
                :key="item.ID"
              >
                <router-link
                  :to="{
                    name: 'content',
                    params: { id: item.ID },
                  }"
                  :title="item.Title"
                  target="_blank"
                >
                  <i :class="article_icon"></i>
                  <span v-html="item.Title"></span>
                </router-link>
                <span class="date">{{ item.CreatedAt | formatDate }}</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="12"
          :xs="24"
        >
          <div class="box">
            <div class="box-title">
              <router-link :to="{
                  name: 'channel',
                  params: { channelID: '5cb3f0a9e1382306c3acac5d' },
                }">
                <i class="fas fa-list"></i>通知公告
              </router-link>
              <router-link
                :to="{
                  name: 'channel',
                  params: { channelID: '5cb3f0a9e1382306c3acac5d' },
                }"
                class="more"
              >
                更多...
              </router-link>
            </div>
            <div class="box-content">
              <p
                class="item dateGroup"
                v-for="item in ajaxItemsNewsGongGao"
                :key="item.ID"
              >
                <router-link
                  :to="{
                    name: 'content',
                    params: { id: item.ID },
                  }"
                  :title="item.Title"
                  target="_blank"
                >
                  <i :class="article_icon"></i>
                  <span v-html="item.Title"></span>
                </router-link>
                <span class="date">{{ item.CreatedAt | formatDate }}</span>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="bg1">
      <div
        class="clearfix container"
        id="IndexAbout"
      >
        <el-col :span="24">
          <div class="box">
            <img
              src="../assets/about.png"
              alt
            />
          </div>
        </el-col>
        <el-col
          :span="6"
          :xs="24"
        >
          <div class="box box-academic">
            <div class="box-image">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0b9e1382306c3acac5e' },
                }">
                <img
                  src="../assets/about_1.jpg"
                  alt
                />
              </router-link>
            </div>
            <h4 class="title">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0b9e1382306c3acac5e' },
                }">
                研究院简介
              </router-link>
            </h4>
            <div class="description">
              为贯彻落实中央“教育援青”战略决策，充分发挥北京师范大学人才和科技优势，推进青海教育优先发展。在教育部的大力支持和指导下，青海省...
            </div>
          </div>
        </el-col>
        <el-col
          :span="6"
          :xs="24"
        >
          <div class="box box-academic">
            <div class="box-image">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0cbe1382306c3acac60' },
                }">
                <img
                  src="../assets/about_2.jpg"
                  alt
                />
              </router-link>
            </div>
            <h4 class="title">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0cbe1382306c3acac60' },
                }">
                理事会
              </router-link>
            </h4>
            <div class="description">
              理事会为指导与促进研究院发展的决策机构，实行单位理事制度，由研究院聘请关心和支持高原科学与可持续发展研究的各级政府、科研院所....
            </div>
          </div>
        </el-col>
        <el-col
          :span="6"
          :xs="24"
        >
          <div class="box box-academic">
            <div class="box-image">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0d1e1382306c3acac61' },
                }">
                <img
                  src="../assets/about_3.jpg"
                  alt
                />
              </router-link>
            </div>
            <h4 class="title">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0d1e1382306c3acac61' },
                }">
                院领导简介
              </router-link>
            </h4>
            <div class="description">
              青海师范大学校长、欧亚科学院院士、研究院院长兼学术委员会秘书长
            </div>
          </div>
        </el-col>
        <el-col
          :span="6"
          :xs="24"
        >
          <div class="box box-academic">
            <div class="box-image">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0d8e1382306c3acac62' },
                }">
                <img
                  src="../assets/about_4.jpg"
                  alt
                />
              </router-link>
            </div>
            <h4 class="title">
              <router-link :to="{
                  name: 'about',
                  params: { channelID: '5cb3f0d8e1382306c3acac62' },
                }">
                联系我们
              </router-link>
            </h4>
            <div class="description">
              地址：青海省西宁市城北区学院路青海师范大学新校区
              <br />邮编：810008 电话：0971-6307653
            </div>
          </div>
        </el-col>
      </div>
    </el-row>
    <el-row class="bg2">
      <div class="clearfix container">
        <el-col :span="24">
          <div class="box">
            <img
              src="../assets/research.png"
              alt
            />
          </div>
        </el-col>
        <el-col
          :span="8"
          :xs="24"
        >
          <div class="box box-academic">
            <h4 class="title">
              <a href="./about_5cb3f072e1382306c3acac56"><i class="fas fa-compass"></i>高原教育领域</a>
            </h4>
            <div class="description">
              一是高原缺氧环境下的脑认知研究。关注高原学生在低氧环境下脑认知功能与适应性机制、学习效果的研究。二是高原地区双语教育教学的研究。关注双语教学模式与构建学生学习能力相适应的双语教学体系，开展双语教材编译和双语教学资源开发，建立双语教育教学资源库，制订双语教育教学质量标准...
            </div>
          </div>
        </el-col>
        <el-col
          :span="8"
          :xs="24"
        >
          <div class="box box-academic">
            <h4 class="title">
              <a href="./about_5cb3f072e1382306c3acac56"><i class="fas fa-compass"></i>高原文化领域</a>
            </h4>
            <div class="description">
              一是高原民族变化与融合发展研究。关注高原多民族文化互鉴与交流，探究“一带一路”国家文化交流历史、经验与教训，地缘关系，构建睦邻友好发展范式等。二是高原观光产业发展研究。挖掘高原地区的特色优势文化资源，够建高原特色优势文化资源开发利用的创新、协调、绿色、开放、共享发展模式等。
            </div>
          </div>
        </el-col>
        <el-col
          :span="8"
          :xs="24"
        >
          <div class="box box-academic">
            <h4 class="title">
              <a href="./about_5cb3f072e1382306c3acac56"><i class="fas fa-compass"></i>高原资源与环境领域</a>
            </h4>
            <div class="description">
              一是理解高原资源与环境变化。关注高原地表过程与资源和生态环境演变规律，理解全球气候变化的“源与汇”，人类活动对资源和生态环境演变的影响等。二是量化资源合理、高效、可持续利用。建立资源动态监测体系、量化评估体系、构建可持续利用模式等。
            </div>
          </div>
        </el-col>
        <div class="clearfix"></div>
        <el-col
          :span="8"
          :xs="24"
        >
          <div class="box box-academic">
            <h4 class="title">
              <a href="./about_5cb3f072e1382306c3acac56"><i class="fas fa-compass"></i>高原生物领域</a>
            </h4>
            <div class="description">
              一是高原极端环境下生物生长与发育研究。关注解决高原动、植物和微生物（特别是微藻）在缺氧和高辐射环境下的生长与发育机理和适应过程等。二是高原新型现代化农林草业、生态产业发展模式研究。探讨建立“多采光、少用水、高产出”的现代化设施生物产业技术-经济体系，关注高原大农业与生态产业结构优化与互补体系、生态与生物安全体系、高原国家公园体系的建立等。
            </div>
          </div>
        </el-col>
        <el-col
          :span="8"
          :xs="24"
        >
          <div class="box box-academic">
            <h4 class="title">
              <a href="./about_5cb3f072e1382306c3acac56"><i class="fas fa-compass"></i>高原健康领域</a>
            </h4>
            <div class="description">
              一是高原缺氧环境与人体和家畜高原病理。关注高原地区缺氧、寒冷、干燥、紫外线辐射强等极端环境与极端气候条件下对人体和家畜的损伤、危害机理等。二是人畜高原病的防治。研发防御高原病的临床技术、改善局部缺氧设施的通用技术，构建改善缺氧环境与人畜健康的自然条件与社会经济条件的技术与经济模式等。
            </div>
          </div>
        </el-col>
        <el-col
          :span="8"
          :xs="24"
        >
          <div class="box box-academic">
            <h4 class="title">
              <a href="./about_5cb3f072e1382306c3acac56"><i class="fas fa-compass"></i>高原防灾减灾领域</a>
            </h4>
            <div class="description">
              一是理解高原灾害形成规律。关注地质、地震与气象水文灾害及多灾种、灾害链、灾害遭遇的理解与区域灾害风险评估。二是构建综合灾害风险防御范式。量化综合灾害风险防范评价与区域模式，建立快捷、准确的灾情预警和评估体系，构建预防各类灾害的方案和应急响应技术等。
            </div>
          </div>
        </el-col>
      </div>
    </el-row>
    <el-row class="bg1">
      <div class="clearfix container">
        <el-col :span="24">
          <div class="box">
            <img
              src="../assets/academic.png"
              alt
            />
          </div>
        </el-col>
        <template v-for="(item, index) in ajaxItemsNewsAcademic">
          <el-col
            :span="12"
            :xs="24"
            :key="item.ID"
          >
            <div class="box box-academic">
              <h4 class="title">
                <router-link
                  :to="{
                    name: 'content',
                    params: { id: item.ID },
                  }"
                  v-html="item.Title"
                  :title="item.Title"
                  target="_blank"
                >
                </router-link>
              </h4>
              <div class="description">
                {{ item.Description | formatHTMLLength }}
              </div>
            </div>
          </el-col>
          <template v-if="(index + 1) % 2 == 0">
            <div
              :class="'clearfix clearfix-' + index"
              :key="'clearfix' + index"
            ></div>
          </template>
        </template>
      </div>
    </el-row>
    <el-row class="bg2">
      <div
        class="clearfix container"
        id="IndexTeam"
      >
        <el-col :span="24">
          <div class="box">
            <img
              src="../assets/team.png"
              alt
            />
          </div>
        </el-col>
        <el-col
          :span="3"
          :xs="8"
          v-for="item in ajaxItemsNewsTeam"
          :key="item.ID"
        >
          <div class="box">
            <router-link
              :to="{
                name: 'content',
                params: { id: item.ID },
              }"
              :title="item.Title"
              target="_blank"
            >
              <img
                :src="item.Attachment"
                :alt="item.Title | formatHTML2Str"
              />
              <span
                class="person"
                v-html="item.Title"
              ></span>
            </router-link>
          </div>
        </el-col>
      </div>
    </el-row>
    <el-row class="bg1">
      <div class="clearfix container">
        <el-col :span="24">
          <div class="box">
            <img
              src="../assets/colla.png"
              alt
            />
          </div>
        </el-col>
        <el-col
          :span="24"
          id="IndexLink"
        >
          <div class="box">
            <router-link
              class="el-button el-button--default el-button--small is-round"
              v-for="item in ajaxItemsNewsCollaborate"
              :key="item.ID"
              :title="item.Title"
              :to="util.absItemURL(item.ID, item.Link)"
              v-html="item.Title"
              target="_blank"
            >
            </router-link>
          </div>
        </el-col>
      </div>
    </el-row>
    <template v-if="AdGroupBoxShow">
      <div
        ref="adGroupRoll"
        id="adGroupRoll"
        v-on:mouseover="AdGroupBoxMouseOver($event)"
        v-on:mouseout="AdGroupBoxMouseOut($event)"
      >
        <template v-if="AdGroupBox.url.length>10">
          <a
            :href="AdGroupBox.url"
            target="_blank"
          ><img
              :src="AdGroupBox.image"
              :alt="AdGroupBox.title"
            ></a>
        </template>
        <template v-else>
          <img
            :src="AdGroupBox.image"
            :alt="AdGroupBox.title"
          >
        </template>
      </div>
    </template>
  </div>
</template>

<script>
  import util from "@libs/util";
  import model from "@libs/model";
  export default {
    name: "home",
    data() {
      return {
        title: util.title(),
        util: util,
        ajaxItemsNewsFirst: {},
        ajaxItemsNews: [],
        ajaxItemsBanners: [],
        ajaxItemsNewsCarousel: [],
        ajaxItemsNewsMeiTi: [],
        ajaxItemsNewsGongGao: [],
        ajaxItemsNewsAbout: [],
        ajaxItemsNewsResearch: [],
        ajaxItemsNewsAcademic: [],
        ajaxItemsNewsTeam: [],
        ajaxItemsNewsCollaborate: [],
        article_icon: util.defaultArticleICON,
        swiperOption: {
          loop: true,
          speed: 1500,
          navigation: {
            nextEl: ".banners .swiper-button-next",
            prevEl: ".banners .swiper-button-prev"
          }
        },
        mySwiperNewsOption: {
          loop: true,
          speed: 3000,
          navigation: {
            nextEl: ".index_news_photo .swiper-button-next",
            prevEl: ".index_news_photo .swiper-button-prev"
          }
        },
        // swiperOption: {
        //   loop: true,
        //   speed: 2000,
        //   autoUpdate: true,
        //   slidesPerView: 1,
        //   preventClicksPropagation: true,
        //   grabCursor: true,
        //   initialSlide: 0,
        //   autoplay: {
        //     delay: 3000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true
        //   },
        //   pagination: {
        //     el: ".swiper-pagination",
        //     clickable: true
        //   },
        //   navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev"
        //   }
        // },
        // mySwiperNewsOption: {
        //   loop: true,
        //   speed: 1000,
        //   autoplay: {
        //     delay: 2000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true
        //   }
        // },
        AdGroupBox: {},
        AdGroupBoxShow: false,
        AdGroupBoxInterval: null,
        AdGroupBoxGGRoll: {}
      };
    },
    components: {},
    directives: {},
    computed: {
      // swiper() {
      //   return [this.$refs.mySwiper.$swiper, this.$refs.mySwiperNews.$swiper];
      // }
    },
    mounted() {
      // console.log("this is current swiper instance object", this.swiper);
      // this.swiper.slideTo(3, 1000, false);
      this.init();
    },
    methods: {
      callback() {},
      AdGroupBoxMouseOver($event) {
        console.log("stop----");
        clearInterval(this.AdGroupBoxInterval);
      },
      AdGroupBoxMouseOut($event) {
        let that = this;
        this.AdGroupBoxInterval = setInterval(function() {
          that.AdGroupBoxGGRoll.Go();
        }, that.AdGroupBoxGGRoll.speed);
      },
      init() {
        // 加载动态广告信息
        if (
          typeof window.GlobalConfig != undefined &&
          "object" == typeof window.GlobalConfig.AdGroup
        ) {
          if (window.GlobalConfig.AdGroup.length > 0) {
            this.AdGroupBox = window.GlobalConfig.AdGroup[0];
            if (
              typeof this.AdGroupBox == "object" &&
              Object.keys(this.AdGroupBox).length == 3
            ) {
              this.AdGroupBoxShow = true;
            }
          }
        }
        let that = this;
        this.$nextTick(function() {
          if (that.AdGroupBoxShow) {
            const tmpGroupRoll = document.getElementById("adGroupRoll");
            // console.log("this.$refs", this.$refs);
            // console.log("this.$refs", this.$refs["adGroupRoll"]);
            // console.log("tmpGroupRoll", tmpGroupRoll);
            // console.log("tmpGroupRoll.offsetWidth", tmpGroupRoll.offsetWidth);
            that.AdGroupBoxGGRoll = {
              //创建对象直接量
              roll: tmpGroupRoll, //获取id属性为roll的对象
              speed: 20, //飘动速度，即为定时器函数多长时间执行一次
              statusX: 1, //规定每执行一次函数，left属性值变化的幅度
              statusY: 1, //规定每执行一次函数，top属性值变化的幅度
              x: 0, //规定初始状态下left属性的值
              y: 400, //规定初始状态下top属性的值
              //差值用来测算left属性值的极限
              winW:
                document.documentElement.clientWidth - tmpGroupRoll.offsetWidth,
              //差值用来测算top属性值的极限
              winH:
                document.documentElement.clientHeight - tmpGroupRoll.offsetHeight,
              //声明函数
              Go: function() {
                //设置div的left属性值
                this.roll.style.left = this.x + "px";
                //设置div的top属性值
                this.roll.style.top = this.y + "px";
                //如果statusX=1则每次减少1px,否则减少1px
                this.x = this.x + (this.statusX ? -1 : 1);
                //如果left属性值小于0，也就是div要超出左边界了，就将statusX设置为0
                if (this.x < 0) {
                  this.statusX = 0;
                }
                //如果top属性值大于winW，也就是div要超出右边界了，就将statusX设置为1
                if (this.x > this.winW) {
                  this.statusX = 1;
                }

                this.y = this.y + (this.statusY ? -1 : 1);
                if (this.y < 0) {
                  this.statusY = 0;
                }
                if (this.y > this.winH) {
                  this.statusY = 1;
                }
              }
            };
            // this.AdGroupBoxGGRoll = ggRoll;
            that.AdGroupBoxInterval = setInterval(function() {
              that.AdGroupBoxGGRoll.Go();
            }, that.AdGroupBoxGGRoll.speed);
            //onmouseover属性：鼠标移动到元素上时触发
            //onmouseout属性:鼠标离开元素时触发
          }
        });

        // 新闻头条
        // model
        //   .http(
        //     "/public/javascript/global/article_topic_100000000000000000000001.js"
        //   )
        //   .then(response => {
        //     this.ajaxItemsNewsFirst = response.data;
        //   });

        // 新闻动态 5cb3f079e1382306c3acac57
        model
          .GetArticlesByChannelID("5cb3f079e1382306c3acac57")
          .then(response => {
            if (response.data.status == 1) {
              this.ajaxItemsNews = response.data.Items;
            }
          });
        // 首页高清图集 5cb67b6ae138235543fc25b4
        this.ajaxItemsBanners = [
          {
            Attachment:
              "http://apss.qhnu.edu.cn/public/apss.qhnu.edu.cn/uploader/image/2020/04/07/5e8c1d8fe1382379ca2d3b72.jpg",
            CreatedAt: "2020-01-02 15:15",
            CreatedByUser: "Manager",
            Description: "",
            ID: "5e0d9886e1382309cc85cb33",
            Link: "",
            ReadCount: 2,
            Source: "",
            SourceAuthor: "",
            SubTitle: "",
            Title: "高清图集(首页)_004",
            URL: "/content/5e0d9886e1382309cc85cb33.html"
          },
          {
            Attachment:
              "http://apss.qhnu.edu.cn/public/apss.qhnu.edu.cn/uploader/image/2020/04/07/5e8c1d79e1382379ca2d3b71.jpg",
            CreatedAt: "2019-04-19 18:50",
            CreatedByUser: "admin",
            Description: "",
            ID: "5cb999f3e1382330e12c23e4",
            Link: "",
            ReadCount: 2,
            Source: "",
            SourceAuthor: "",
            SubTitle: "",
            Title: "高清图集(首页)",
            URL: "/content/5cb999f3e1382330e12c23e4.html"
          }
        ];
        model
          .GetArticlesByChannelID("5cb67b6ae138235543fc25b4")
          .then(response => {
            if (response.data.status == 1) {
              this.ajaxItemsBanners = response.data.Items;
            }
          });

        // 新闻轮显 http://apss.qhnu.edu.cn/api/article/carousel
        this.ajaxItemsNewsCarousel = this.ajaxItemsBanners;
        model.http("/api/article/carousel").then(response => {
          if (response.data.status == 1) {
            this.ajaxItemsNewsCarousel = response.data.Items;
          }
        });
        // 媒体报道 5cb3f083e1382306c3acac58
        model
          .GetArticlesByChannelID("5cb3f083e1382306c3acac58")
          .then(response => {
            if (response.data.status == 1) {
              this.ajaxItemsNewsMeiTi = response.data.Items;
            }
          });
        // 通知公告 5cb3f0a9e1382306c3acac5d
        model
          .GetArticlesByChannelID("5cb3f0a9e1382306c3acac5d")
          .then(response => {
            if (response.data.status == 1) {
              this.ajaxItemsNewsGongGao = response.data.Items;
            }
          });
        // 关于我们 5cb3f063e1382306c3acac55
        // this.ajaxItemsNewsAbout: []

        // 研究领域 5cb3f072e1382306c3acac56
        // model
        //   .GetArticlesByChannelID("5cb3f072e1382306c3acac56")
        //   .then(response => {
        //     if (response.data.status == 1) {
        //       this.ajaxItemsNewsResearch = response.data.Items;
        //     }
        //   });
        // 学术观点 5cb3f0a2e1382306c3acac5c
        model
          .GetArticlesByChannelID("5cb3f0a2e1382306c3acac5c")
          .then(response => {
            if (response.data.status == 1) {
              this.ajaxItemsNewsAcademic = response.data.Items;
            }
          });
        // 专家团队 5cb3f08be1382306c3acac59
        model
          .GetArticlesByChannelID("5cb3f08be1382306c3acac59")
          .then(response => {
            if (response.data.status == 1) {
              this.ajaxItemsNewsTeam = response.data.Items;
            }
          });
        // 合作机构 5cb3f09be1382306c3acac5b
        model
          .GetArticlesByChannelID("5cb3f09be1382306c3acac5b", 0, 30)
          .then(response => {
            if (response.data.status == 1) {
              this.ajaxItemsNewsCollaborate = response.data.Items;
            }
          });
      }
    }
  };
</script>

<style scoped>
  #adGroupRoll {
    height: 200px;
    width: 280px;
    position: fixed; /*fixed实现绝对定位*/
    cursor: pointer;
    z-index: 99999;
  }
  #adGroupRoll img {
    width: 280px;
  }

  .banners {
    margin: 0;
    padding: 0;
    background: rgb(56, 95, 127);
    overflow: hidden;
    width: 100%;
  }

  .toutiao {
    background: #577e9b url(../assets/toutiao_bg.png) left center no-repeat;
    background-size: auto 100%;
  }

  .toutiao_content {
    padding: 24px 12px 24px 160px;
    background: url(../assets/toutiao.png) left 30px no-repeat;
    min-height: 104px;
    color: #ddd;
  }

  .toutiao_content h1 {
    padding-bottom: 12px;
    margin: 30px 0 0 0;
    font-size: 28px;
    line-height: 1.4em;
  }

  .toutiao_content h1,
  .toutiao_content h1 a {
    color: #fff;
    font-weight: 700;
    text-shadow: 1px 0 2px rgba(0, 0, 0, 0.7);
  }

  .toutiao_content:hover {
    color: #fff;
  }

  .toutiao_content:hover h1,
  .toutiao_content:hover h1 a {
    color: #333;
    text-shadow: -1px 0 2px rgba(255, 255, 255, 1);
  }

  .index_news_photo .swiper-slide,
  .index_news_photo .swiper-slide img {
    width: 100%;
    height: 350px;
    overflow: hidden;
  }

  .index_news_photo .index_news_photo_swiper_text {
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    color: #eee;
    width: 100%;
  }

  .index_news_photo .index_news_photo_swiper_text a {
    display: block;
    margin: 6px 12px;
    color: #eee;
  }

  .bg1 {
    background: #f6f6f6;
    padding: 24px 0;
  }

  .bg2 {
    background: #fff;
    padding: 24px 0;
  }

  #IndexLink .el-button {
    margin: 12px 12px 0 0;
  }

  #IndexTeam a {
    display: block;
  }

  #IndexTeam div a img {
    width: 100%;
  }

  #IndexTeam span.person {
    display: block;
    text-align: center;
    margin: 0;
    padding: 0 0 0 0;
  }

  .box-academic {
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.8);
    padding-bottom: 12px;
    -webkit-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    transition: all 300ms;
  }

  .box-academic:hover {
    background: #fff;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.2);
  }

  .box-academic .title,
  .box-academic .title a {
    display: block;
    font-size: 1.1em;
    color: rgba(56, 95, 127, 1);
    margin: 8px 0 4px 0;
  }

  .box-academic .description {
    color: #888;
  }

  #IndexAbout > div {
    z-index: 1;
  }

  #IndexAbout > div > div.box-academic {
    min-height: 320px;
    padding: 0;
    border: 12px solid transparent;
  }

  #IndexAbout > div > div.box-academic:hover {
    z-index: 9001;
    background: #fff;
    box-shadow: 0 0 24px rgba(56, 95, 127, 0.5);
  }

  #IndexAbout > div > div.box-academic .box-image {
    overflow: hidden;
    margin: 0 0 12px 0;
  }

  #IndexAbout > div > div.box-academic .box-image img {
    width: 100%;
    -webkit-transition: all 400ms;
    -ms-transition: all 400ms;
    -o-transition: all 400ms;
    transition: all 400ms;
  }

  #IndexAbout > div > div.box-academic:hover .box-image img {
    -webkit-transform: scale(1.4);
    -ms-transform: scale(1.4);
    -o-transform: scale(1.4);
    transform: scale(1.4);
  }
</style>

<style>
  .banners * img {
    margin: 0;
  }

  .swiper-pagination-bullet {
    width: 30px;
    height: 3px;
    border-radius: 0;
  }
</style>
